import React from 'react';

import { POLICIES, Authorization } from '@/lib/Authorization';
import { FallbackCard } from '@repo/ui/Card';
import { MainView } from '@repo/ui/Views';

import DidsTable from '../components/DidsTable';
import { useUser } from '@repo/hooks/useUser';
import { useAccount } from '@/hooks/useAccount';

const Dids = () => {
  const user = useUser();
  const account = useAccount();
  const accountId = account.id;

  return (
    <MainView title="Numbers">
      <Authorization
        policyCheck={POLICIES['dids:index'](user)}
        fallbackView={
          <FallbackCard
            title="No access"
            description="You do not have permissions to view numbers."
          />
        }
      >
        <div className="flex flex-col">
          <h2 className="mb-6 text-2xl font-bold sm:text-3xl dark:text-blue-100">Inventory</h2>
          <DidsTable accountId={Array.isArray(accountId) ? accountId[0] : accountId} />
        </div>
      </Authorization>
    </MainView>
  );
};

export default Dids;
